$(document).ready(function () {
  var checkboxes = document.querySelectorAll('.custom-checkbox-input');
  checkboxes.forEach(function (checkbox, index) {
    checkbox.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        event.preventDefault();
        var nextIndex = event.key === 'ArrowUp' ? index - 1 : index + 1;
        if (nextIndex < 0) {
          nextIndex = checkboxes.length - 1;
        } else if (nextIndex >= checkboxes.length) {
          nextIndex = 0;
        }
        checkboxes[nextIndex].focus();
      }
    });
  });
  /* Track an order page */  
  $('#tracktorTrack').focus(function(){
    $(this).css('outline', ' 2px solid #046095');
  });
  $('#tracktorTrack').blur(function(){
    $(this).css('outline', 'none');
  });
  /* Skip to content CTA */
  $(".PageSkipLink").on("click", function(e) {
    e.preventDefault();
    $("#main").attr("tabindex", "-1").focus();
  });
  $(document).on('focus', '.tracktor-marker', function() {
    $(this).attr('aria-label', 'Shipping to Marked Location');
    $(this).attr('role', 'button');
  });
  /* Adding tab index for all CTA and anchor tag */  
  var tabindex = 0;
  $('.tabindexfunction,a,button').each(function() {
    if (this.type != "hidden") {
      var $input = $(this);
      $input.attr("tabindex", "0");
      tabindex++;
    }
  });  
    
  $(".carousel-cell").attr("aria-hidden", "false");
  $(".Product__Slideshow").attr("tabindex", "-1");
  $(".Product__SlideItem.Carousel__Cell.is-selected").attr("tabindex", "0");  
  
  /* Header accessibillity fixes */
  $(".HorizontalList__Item").first().find("a.Heading.u-h6.main-links").attr("tabindex", 0).on("keydown", function (e) {
    if (e.shiftKey && e.key === "Tab") {
      $(".MegaMenu__Close").trigger("click");
      $(".HorizontalList__Item_Append a").attr("aria-expanded", "false");
    }
  });
  $(".Header__LogoLink").on("focus", function () {
    $(".HorizontalList__Item").removeClass("MegaMenu__is_open");
  });
  $(".Search__Icon").on("focus", function () {
    $(".openMyRcDropdown").removeClass("DropdownMenu__is-open");
  });
  $(".connect-js").on("focus", function () {
    $(".openMyRcDropdown").removeClass("DropdownMenu__is-open");
  });
  $(".HorizontalList__Item").first().find("a.Heading.u-h6").on("keydown", function (e) {
    var keyCode = e.keyCode || e.which;
    if(keyCode == 39) {
      e.preventDefault();
      $(".HorizontalList__Item").eq(1).find("a.Heading.u-h6").focus();
    }
  });
  $(".HorizontalList__Item").eq(1).find("a.Heading.u-h6").on("keydown", function (e) {
    var keyCode = e.keyCode || e.which;
    if(keyCode == 39 || keyCode == 37) {
      e.preventDefault();
      keyCode === 39 ? $(".HorizontalList__Item").eq(2).find("a.Heading.u-h6").focus() : $(".HorizontalList__Item").eq(0).find("a.Heading.u-h6").focus();
    }
  });
  $(".HorizontalList__Item").eq(2).find("a.Heading.u-h6").on("keydown", function (e) {
    var keyCode = e.keyCode || e.which;
    if(keyCode == 39 || keyCode == 37) {
      e.preventDefault();
      keyCode === 39 ? $(".HorizontalList__Item").eq(3).find("a.Heading.u-h6").focus() : $(".HorizontalList__Item").eq(1).find("a.Heading.u-h6").focus();
    }
  });
  $(".HorizontalList__Item").eq(3).find("a.Heading.u-h6").on("keydown", function (e) {
    var keyCode = e.keyCode || e.which;
    if(keyCode == 39 || keyCode == 37) {
      e.preventDefault();
      keyCode === 39 ? $(".HorizontalList__Item").eq(4).find("a.Heading.u-h6").focus() : $(".HorizontalList__Item").eq(2).find("a.Heading.u-h6").focus();
    }
  });
  $(".HorizontalList__Item").eq(4).find("a.Heading.u-h6").on("keydown", function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode == 37) {
      e.preventDefault();
      $(".HorizontalList__Item").eq(3).find("a.Heading.u-h6").focus();
    }
  });

  var inputTimeout;
  $('#searchInput').on('input', function() {
    clearTimeout(inputTimeout);
    inputTimeout = setTimeout(function() {
      var dynamicCount = $('#DynamicSearchResult').text().trim();
      // Update the search description with the fetched dynamic count or set a custom aria label
      var inputValue = $('#searchInput')?.val()?.trim();
      var descriptionElement = $('#typeahead-description');
      
      if (inputValue === '') {
        descriptionElement.attr('aria-label', 'Suggestions will be provided as you type.');
      } else {
        var dynamicLabel = "Results for '" + inputValue + "': " + dynamicCount;
        descriptionElement.text(dynamicLabel).removeAttr('aria-label');
      }
    }, 700);
  });
  /* Header accessibillity fixes end */
  
  /*Remove Image hover extra focus */
  setInterval(function () {
   $("a.xs-hidden.productitem__imagewrapper.productitem__imagewrapper--withalternateimage").attr("tabindex", "0");
   $("a.xs-hidden.productitem__imagewrapper.productitem__imagewrapper--withalternateimage:hover").attr("tabindex", "-1");
  }, 100);

  const $items = $("a.xs-hidden.productitem__imagewrapper.productitem__imagewrapper--withalternateimage");
  $items.on("mouseenter", function () {
    $(this).data("hovered", true).attr({ tabindex: "-1","aria-hidden": "true",role: "presentation"});
  })
  .on("mouseleave", function () {
    $(this).data("hovered", false).attr({ tabindex: "0","aria-hidden": "false"});
  })
  .on("focus", function () {
    const $el = $(this);
    setTimeout(() => {
      const isHovered = $el.data("hovered");
      $el.attr("tabindex", isHovered ? "-1" : "0");
      if (isHovered) {
        getNextFocusable($el).focus();
      }
    }, 10);
  });
  function getNextFocusable($el) {
    const $focusables = $('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
      .filter(':visible:not([disabled])')
      .filter(function () {
        const $t = $(this);
        return $t.css('visibility') !== 'hidden' && $t.css('display') !== 'none';
      });
    const index = $focusables.index($el);
    return $focusables.eq(index + 1);
  } 

  // PDP slider
  $(document).ready(function () {
    var $Product__Slideshow = $(".Product__Slideshow").flickity({
      groupCells: true,
    });
    $(".flickity-page-dots").on("focus", ".dot", function () {
      var index = $(this).index();
      $Product__Slideshow.flickity("selectCell", index);
    });
    $Product__Slideshow.on('select.flickity', function() {
      $(".flickity-page-dots").find("li.dot").removeAttr("aria-current");
      $(".flickity-page-dots").find("li.dot.is-selected").attr("aria-current", "page");
    });
  });
  
  setTimeout(function () {
    $(".flickity-page-dots").not(".sizeguide-drawer .flickity-page-dots").find("li.dot").attr({
      role: "button",
      tabindex: 0,
    });
    $(".flickity-page-dots").find("li.dot.is-selected").attr("aria-current", "page");
    $(".shg-sld-dots, .shg-sld-content")
    .find(".shg-sld-dot, .shg-sld-nav-button")
    .attr({
      role: "button",
      tabindex: 0,
    })
    .attr("aria-label", "subLnk_01");
    $(".shg-sld-dot").keypress(function (e) {
    var index = $(this).index();
    var key = e.which;
    if (key == 13) {
      // the enter key code
      $(this)[0].click(index);
      return false;
    }
    });
  }, 2500);
  
  $(".pdp-product-slideshowNavPlay").keypress(function () {
    $(".goal").click();
  });
  
  function tabIndexFocus() {
    $(".focusClass").attr("tabindex", -1);
  }
  
  setTimeout(function () {
    $(".tangiblee-cta-wrapper").find(".tangiblee-cta").attr("tabindex", 0);
    $(".product-card-container").find(".ProductListWrapper").find(".ProductList--carousel").attr("tabindex",-1);
  }, 2000);
  
  tabIndexFocus();
  
  $(".shg-sld-right").attr("tabindex", 0);
  $(".shg-sld-left").attr("tabindex", 0);
  
  $(".shg-sld-right").keypress(function () {
    $(".shg-sld-right").click();
  });
  
  $(".shg-sld-left").keypress(function () {
    $(".shg-sld-left").click();
  });
  
  // For the Footer flag & Privacy Policy...DON'T DELETE
  $(".footer__storename").on("keydown", function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 9) {
      e.preventDefault();
      $("iframe#chat-button").focus();
    }
  });
  
  $(".footer__storename").on("keydown blur", function (e) {
    if (e.shiftKey && e.keyCode === 9) {
      $(".link--primary").last().focus();
    }
  });
  
  // For the page Select Diamond keyboard accessibility...
  if ($(location).attr("pathname") == "/pages/select-diamond") {
    $(".PageSkipLink").on("keydown", function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode == 9) {
      e.preventDefault();
      $(".close__header--view-collection").focus();
    }
    });
  }
  
  // For the page Compare Diamond keyboard accessibility...
  if ($(location).attr("pathname") == "/pages/diamond-compare") {
    $(".PageSkipLink").on("keydown", function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode == 9) {
      e.preventDefault();
      $(".back-to-diamond-feed").focus();
    }
    });
  }
  
  $(".dot").focus(function () {
    clickDots();
  });
    
  function clickDots(){
    $(".dot").each(function(index) {
      if($(this).is(":focus")){
        $(this).click();
      }
    });
  }
  
  /* Collection page Arrow key functionality */
  $("button.boost-pfs-filter-button.boost-pfs-filter-option-title-heading").eq(1).on("keydown", function (e) {
    var keyCode = e.keyCode || e.which
    if(keyCode == 39) {
      e.preventDefault()
      $("button.boost-pfs-filter-button.boost-pfs-filter-option-title-heading").eq(2).focus()
    }
  })
  $("button.boost-pfs-filter-button.boost-pfs-filter-option-title-heading").eq(2).on("keydown", function (e) {
    var keyCode = e.keyCode || e.which
    if(keyCode == 39 || keyCode == 37) {
      e.preventDefault()
      keyCode === 39 ? $("button.boost-pfs-filter-button.boost-pfs-filter-option-title-heading").eq(3).focus() : $("button.boost-pfs-filter-button.boost-pfs-filter-option-title-heading").eq(1).focus()
    }
  })
  $("button.boost-pfs-filter-button.boost-pfs-filter-option-title-heading").eq(3).on("keydown", function (e) {
    var keyCode = e.keyCode || e.which
    if(keyCode == 39 || keyCode == 37) {
      e.preventDefault()
      keyCode === 39 ? $("button.boost-pfs-filter-button.boost-pfs-filter-option-title-heading").eq(4).focus() : $("button.boost-pfs-filter-button.boost-pfs-filter-option-title-heading").eq(2).focus()
    }
  })
  $("button.boost-pfs-filter-button.boost-pfs-filter-option-title-heading").eq(4).on("keydown", function (e) {
    var keyCode = e.keyCode || e.which
    if(keyCode == 39 || keyCode == 37) {
      e.preventDefault()
      keyCode == 39 ? $("button.collectiontoolbar__item.collectiontoolbar__item--sort.heading.text--subdued.u-h6").focus() : $("button.boost-pfs-filter-button.boost-pfs-filter-option-title-heading").eq(3).focus()
    }
  })
  $("button.collectiontoolbar__item.collectiontoolbar__item--sort.heading.text--subdued.u-h6").on("keydown", function (e) {
    var keyCode = e.keyCode || e.which
    if(keyCode == 39 || keyCode == 37) {
      e.preventDefault()
      if(keyCode == 37) $("button.boost-pfs-filter-button.boost-pfs-filter-option-title-heading").eq(4).focus()
    }
  })

  /* Hidden content read by the screen reader */  
  var targetNode = document.querySelector('body');
  var observer = new MutationObserver(function (mutationsList) {
    for (var i = 0; i < mutationsList.length; i++) {
      var mutation = mutationsList[i];
      if (mutation.type === 'childList') {
        var addedNodes = Array.from(mutation.addedNodes);
        for (var j = 0; j < addedNodes.length; j++) {
          var node = addedNodes[j];
          if (node.id === 'gorgias-chat-container') {
            setTimeout(function () {
              $("#chat-campaigns").attr("tabindex", "-1");
            }, 3000);
            $("#mountHere").attr("newAttribute", "newValue");
            observer.disconnect();
            break;
          }
        }
      }
    }
  });
  observer.observe(targetNode, { childList: true, subtree: true });
});

// For Image select through enter key...
$(".Product__SlideshowNavImage").attr('tabindex',0).removeClass('is-selected');
$(".Product__SlideshowNavImage").keypress(function (e) {
  var index = $(this).index();
  var key = e.which;
  if (key == 13) {
    // the enter key code
    $(this)[0].click(index);
    $(".Product__SlideshowNavImage").removeClass('is-selected')
    return false;
  }
});

// My Rc dropdown Jquery
$("#myrcbuttonheader").click(function () {
  if ($(".dropdown-content").hasClass("hide")) {
    $("#myrcbuttonheader").attr("aria-expanded", "true");
    $(".dropdown-content").removeClass("hide");
  } else {
    $("#myrcbuttonheader").attr("aria-expanded", "false");
    $(".dropdown-content").addClass("hide");
  }
});

// TAB MY RC DROPDOWN-CONTENT CLOSE WHEN FOCUS ON NEXT OR PREVIOUS ELEMENT
function myRcButton(e) {
  if ($("#myrcbuttonheader").attr("aria-expanded") === "true") {
    $("#lastli").on("keydown", function (e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode === 9 && !e.shiftKey) {
        $("#myrcbuttonheader").attr("aria-expanded", "false");
        $(".dropdown-content").addClass("hide");
      } else if (keyCode === 9 && e.shiftKey) {
        $("#secondlast").focus();
      }
    });
  }
}

$(".header__logolink").on("focus", function () {
  $("#myrcbuttonheader").attr("aria-expanded", "false");
  $(".dropdown-content").addClass("hide");
});
$("#myrcbuttonheader").bind("keypress click", function () {
  myRcButton();
});

// OPEN MYRC DROPDOWN AND CLOSE BOX ON CLICK
var focused = document.activeElement;
$(document).on("click", function (e) {
  if ($(e.target).closest("#myrcbuttonheader").length === 0) {
    if (focused || focused !== document.body) {
      $("#myrcbuttonheader").attr("aria-expanded", "false");
      $(".dropdown-content").addClass("hide");
    }
  }
});

// FOR ENGAGEMENT RINGS ALT TEXTS...
if ($(location).attr("pathname") == "/pages/engagement-rings") {
  $(document).on('click keypress', function() {
    $("#parentDiv1").attr({alt: "Bridal Engagement Rings Whisper Thin®"});
    $("#parentDiv2").attr({alt: "Bridal Engagement Rings Whisper Thin® with Pavé"});
    $("#parentDiv3").attr({alt: "Bridal Engagement Rings The 'Devon' Floating Oval Engagement Ring"});
    $("#parentDiv6").attr({alt: "Bridal Engagement Rings Whisper Thin® Three-Stone Oval"});
  })
}

// vow engagement rings
$(".productTabData.productDetailsText p a").attr("aria-label","Learn More here about VOW FAQS");

// Search
$("form.Search__Form").removeAttr("role");
$("form.Search__Form").attr("type","Search");

// pdp page
var get_alt = $(".Product__SlideItem .AspectRatio img").attr('alt');
$('.Product__SlideshowNavScroller span img').attr('alt', get_alt).attr("tabindex", 0);
var get_alt_label = $(".Product__SlideItem .AspectRatio img").attr('alt');
$(".product_slideshow_image").attr('aria-label', get_alt_label);

if (location.pathname.split("/")[2] == "whisper-thin-engagement-ring" && location.pathname.split("/")[1] == "products") {
  var get_alt_label = $(".Product__SlideItem .AspectRatio img").attr('alt');
  $(".product_slideshow_image").attr('aria-label', get_alt_label);
}

var get_alt_text = $(".Product__SlideItem .AspectRatio img").attr('alt');
$('.Product__SlideshowNavImage img').attr('alt', get_alt_text).attr("tabindex", 0);
$('.Product__SlideshowNavImage').attr('tabindex', -1);
setTimeout(function () {
  $('.Product__SlideshowNavScroller').removeAttr('tabindex');
}, 2000)

/* Engravable Products: Toggle Handling */
$(".switch").on("keydown", function (e) {
  var keyCode = e.keyCode || e.which;
  if(keyCode == 13 || keyCode == "Enter") {
    e.preventDefault();
    $("#engravablesInputsWrapperSlider").click();
  }
});

/* Collection Page: In Stock Toggle Handling */
if(pageType == 'collection'){
  $(".switch").on("keydown", function (e) {
    var keyCode = e.keyCode || e.which;
    if(keyCode == 13 || keyCode == "Enter") {
      e.preventDefault();
      $('.in-stock-toggle').click()
    }
  });
}

/* Calls only on product Page */
if(pageType === 'product'){
  /* On Image Zoom, Close Zoomed in image using enter key */
  $(".pswp__button--close").on("keypress", function(event) {
    if (event.which === 13 || event.keyCode === 13) {
      var escapeEvent = new KeyboardEvent("keydown", {
        key: "Escape",
        keyCode: 27,
        which: 27,
        bubbles: true,
        cancelable: true,
      });
      document.dispatchEvent(escapeEvent);
    }
  });
  
  /* On Image Zoom, Call Next image using keyboard */
  $(".pswp__button--next").on("keypress", function(event) {
    if (event.which === 13 || event.keyCode === 13) {
      var rightArrowEvent = new KeyboardEvent("keydown", {
        key: "ArrowRight",
        keyCode: 39,
        which: 39,
        bubbles: true,
        cancelable: true,
      });
      document.dispatchEvent(rightArrowEvent);
    }
  });
  
  /* On Image Zoom, Call Previous image using keyboard */
  $(".pswp__button--prev").on("keypress", function(event) {
    if (event.which === 13 || event.keyCode === 13) {
      var rightArrowEvent = new KeyboardEvent("keydown", {
        key: "ArrowLeft",
        keyCode: 37,
        which: 37,
        bubbles: true,
        cancelable: true,
      });
      document.dispatchEvent(rightArrowEvent);
    }
  });
  
  /* On click of image, show zoomed in image: PDP Slider */
  setTimeout(function () {
    var button = document.querySelector(".Product__Slideshow--zoomable");
    var elementToClick = document.querySelector(".Image--fadeIn.lazyautosizes.Image--lazyLoaded");
    button.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.keyCode === 13) {
        if (document.activeElement === button) {
          if (elementToClick) {
            elementToClick.addEventListener('click', function(event) {
            });
            elementToClick.click();
          }
        }
      }
    });
  }, 3000);

  /* Accessing sharing popup using Keyboard Tab */
  var socialShareModal = document.getElementById('social-share');
  if (socialShareModal) var focusableElements = socialShareModal.querySelectorAll('button, [tabindex]')
  var focusIndex = 0;
  
  $('#close-modal-button').on('keydown', function(event) {
    if (event.keyCode === 13) {
      $('#close-modal-button').trigger('click');
    }
  });
  
  function manageFocus(e) {
    if (e.key === 'Tab' || e.keyCode === 9) {
      if (socialShareModal.style.display !== 'none') {
        e.preventDefault();
        focusableElements[focusIndex].focus();
        if (e.shiftKey) {
          focusIndex = (focusIndex - 1 + focusableElements.length) % focusableElements.length;
        } else {
          focusIndex = (focusIndex + 1) % focusableElements.length;
        }
      }
    }
  }

  if ($('.pdp-share-button').length != 0){
    $('.pdp-share-button').click(function(){
      window.addEventListener('keydown', manageFocus); 
    })
  }
  
  // Initialize tabindex for focusable elements when the modal is displayed
  if (socialShareModal && socialShareModal.style.display !== 'none') {
    focusableElements.forEach((element) => element.tabIndex = -1);
    focusableElements[focusIndex].tabIndex = 0;
  }
  /* Close dropdown when click on Sizechart */
  $(".Popover__FooterHelp[aria-controls='modal-size-chart']").click(function() {
    $('.Popover').attr('aria-hidden','true')
    $('.ProductForm__Item').attr('aria-expanded','false')
  })
}

/* Calls only on Cart Page */
if(pageType === 'cart'){
  /* Accessing Gift Wrap Checkbox using Keyboard Enter Key */
  $('.giftNotewrapcheckbox').on('keydown', function(event) {
    if (event.keyCode === 13) {
      $(this).trigger('click');
    }
  });
  /* Accessing Complimentary Wrap Checkbox using Keyboard Enter Key */
  $('.complimentarywrapcheckbox').on('keydown', function(event) {
    if (event.keyCode === 13) {
      $(this).trigger('click');
    }
  });
}

function toggleSearch() {
  var searchLink = $('.custom-search-nav').attr('aria-hidden') === 'true';
  var $searchButton = $('.Header__Icon.Search__Icon.Icon-Wrapper.Icon-Wrapper--clickable.linktobutton');
  var $mainLinks = $('.HorizontalList__Item a.Heading.u-h6.main-links');
  if (searchLink) {
    $searchButton.attr('aria-expanded', 'true');
    $mainLinks.each(function() {
      $(this).attr('tabindex', -1);
    });
  } else {
    $searchButton.attr('aria-expanded', 'false');
  }
}

$(document).ready(function() {
  $('.Search__Close').on('keydown', function(e) {
    if (e.which === 13 || e.which === 32) { 
      e.preventDefault(); 
      $('#Search').find('.Search__Close').click();   
      $('.HorizontalList__Item a.Heading.u-h6.main-links').each(function() {
        $(this).attr('tabindex', 0);
      }); 
      $('.Header__Icon.Search__Icon.Icon-Wrapper.Icon-Wrapper--clickable.linktobutton').focus();
    }
  });
  $('#Search').find('.Search__Close').on('click', function() {
    $('.HorizontalList__Item a.Heading.u-h6.main-links').each(function() {
      $(this).attr('tabindex', 0);
    });
  });
  function FocusedPageDotTrigger() {
    $('.product-card-carousel-wrapper .product-card-container .ProductList--carousel .flickity-page-dots .dot').on('focus', function () {
      $(this).click();
    });
  }
  function checkScreenSize() {
    if ($(window).width() < 1024) {
      var slides = $('.product-card-container').find('.ProductList, .ProductList--carousel, .Carousel').find('.product-card-container-recent');
      slides.each(function (index, slide) {
        var dots = $(slide).find('.flickity-page-dots .dot');
        $(slide).attr('aria-label', `Slide ${index + 1} of ${slides.length}`);
        dots.each(function (dotIndex, dot) {
          $(dot).attr('aria-label', `Dot ${dotIndex + 1} of ${dots.length} for slide ${index + 1}`);
        });
      });
    }
  }
  FocusedPageDotTrigger();
  checkScreenSize()
})

// Set programmatically aria-selected true false on navslider of click and keypress
function updateAriaSelected() {
  const valueFind = $(".Product__SlideshowNavScroller .carousel-cell button");
  valueFind.each(function (index) {
    const button = $(this);
    button.removeClass("first-selected");

    if (index === 0) {
      button.addClass("first-selected");
    }
  });
  valueFind.on("click", function () {
    const clickedButton = $(this);
    valueFind.not(clickedButton).removeClass("first-selected")
    clickedButton.addClass("first-selected");
  });
  valueFind.on("keydown", function (event) {
    if ((event.which === 13 || event.keyCode === 13) && $(this).is(":focus")) {
      $(this).click();
    }
  });
}

$(document).ready(function () {
  updateAriaSelected();
  const config = { attributes: true, childList: true, subtree: true };

  function handleMutations(mutationsList, observer) {
    const valueImageFind = $(".Product__SlideshowNavScroller .carousel-cell button .Image--fadeIn");
    if (valueImageFind.length > 0) {
      valueImageFind.attr("tabindex", -1);
      observer.disconnect();
    }
  }

  function observeProductSlideshowNavScroller() {
    const targetNode = document.querySelector(".Product__SlideshowNavScroller");
    if (!targetNode) {
      return; // Exit the function if the element is not found
    }
    const observer = new MutationObserver(handleMutations);
    observer.observe(targetNode, config);
  }
  observeProductSlideshowNavScroller();

  // Size Chart on pdp implementation of close button trigger 
  $('.Popover__FooterHelp.Heading.Link.Link--primary.Text--subdued.u-h6').on('click keydown', function (event) {
    if (event.type === 'click' || (event.type === 'keydown' && (event.key === 'Enter' || event.keyCode === 13))) {
      // Focus on the modal
      $('#modal-size-chart').focus();
    }
  });

  var getLengthClosebutton = $('.modal__close.roundbutton.roundbutton--large');
  $(getLengthClosebutton).on('click keydown', function (event) {
    if (event.type === 'click' || (event.type === 'keydown' && (event.key === 'Enter' || event.keyCode === 13))) {
      var alertDiv = $('<div>', {
        'style': 'position: absolute; width: 1px; height: 1px; margin: -1px; padding: 0; overflow: hidden; clip: rect(0, 0, 0, 0); border: 0;',
        'aria-live': 'assertive',
        'role': 'alert',
        'aria-label': 'close modal.'
      }).appendTo('body');
      setTimeout(function () {
        $('.ProductForm__Item.productfor__item--default').focus();
      }, 100);
      setTimeout(function () {
        alertDiv.remove();
      }, 2000);
    }
  });

 // selectDiamond page implementation of close button trigger 
 $('.diamond-popup-close').attr('aria-live', 'polite').attr('role', 'alert');

  // Add new addresson  page implementation of close button trigger 
  $('.Modal__Close.Modal__Close--outside').click(function() {
  var ariaLabel = $(this).attr('aria-label');
  $(this).attr('aria-live', 'polite').attr('role', 'alert').text(ariaLabel);
  });
  
  // add aria-label in the particular link for fine jwellery contact 
  $('a[href="https://ringconcierge.com/apps/tracktor/track"]').attr('aria-label', "Click here for track your order");
  // add aria-label in the particular link for fine jwellery return
  $('a[href="https://ringconcierge.com/apps/returns"]').attr('aria-label', "Click here for return or exchange");
  $('a[href="https://ringconcierge.com/pages/ring-concierge-exchange-policy"]').attr('aria-label', "Click here for Terms and Conditions");
  // add aria-label in the particular link for faq
  $('a[href="https://ringconcierge.com/pages/bridal-consultation-form"]').attr('aria-label', "Click here for Get started with RC");
  $('a[href="https://ringconcierge.com/pages/reset-your-stone"]').attr('aria-label', "Click here for reset-your-stone");
  // add aria-label in the particular link for PDP
  $('a[href="https://ringconcierge.com/pages/warranty-exchanges"]').attr('aria-label', "Click here for Fine Jewelry Returns");
  $('a[href="https://ringconcierge.com/pages/fine-faqs"]').attr('aria-label', "Click here for Fine Jewelry FAQs");
});